module.exports = __webpack_public_path__ + "img/flag_china.c52ac962.png";